import { number, string } from "prop-types";
import { Link } from "@material-ui/core";
import useStyle from "../TextClearInput.style";
import classnames from "classnames";
import { NavigationDataKey } from "@tools/EstimateEditor/hooks/useNavigationKeybinds";

export const Static = ({
  value,
  placeholder,
  className,
  navigationKey,
  tabIndex,
}) => {
  
  const classes = useStyle();
  
  const checkKey = e => {
    const { key, currentTarget } = e;
    if ( document.activeElement === currentTarget && key === "Escape" ) {
      e.stopPropagation();
      currentTarget.blur();
    }
  };
  
  return (
    <>
      <Link
        color="textPrimary"
        href="#"
        tabIndex={tabIndex}
        onKeyDown={ checkKey }
        className={classnames(classes.linkWrapper, className)}
        {...{[NavigationDataKey]: navigationKey}}
      >
        {""}
      </Link>
      <p
        className={classnames(value ? classes.inheritFont : classes.placeholder, "w-full", className)}
      >
        {
          !value
            ? placeholder
            : typeof value === "string"
              ? value.replace(/<([.\n])*?>/g, "")
              : value
        }
      </p>
    </>
    // </Link>
  )
}

Static.propTypes = {
  value: string,
  placeholder: string,
  className: string,
  navigationKey: string,
  tabIndex: number,
}